import React, { useState, useEffect } from 'react';
import './GDPRBanner.css';

const GDPRBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('gdprConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('gdprConsent', 'true');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="gdpr-banner">
      <p>
        We use cookies to ensure you get the best experience on our website. By continuing to use our site, 
        you accept our use of cookies, privacy policy and terms of service.
      </p>
      <button className="accept-btn" onClick={acceptCookies}>
        Accept
      </button>
    </div>
  );
};

export default GDPRBanner; 